/**
 * Loose flagstones and fallen leaves over the town (lifted from lantern-water's
 * `world.js` `createTown`: "quiet details at human scale"): `count` small flat
 * chips at random points of the town (x -19..20, z -16..16 in three.js axes),
 * none on the canal (x 3.2..11), each on its district's ground, two thirds moss
 * and one third brass-coloured leaves, turned at random. Placed at the origin.
 * Its own random stream.
 *
 * Params: `count` (110).
 */
import * as THREE from 'three';
import { num } from '../kit.ts';
import { districtHeight } from './shrub-scatter.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'leaf_litter',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { box, random, m } = ctx;
    const count = num(ctx, 'count', 110);
    for (let i = 0; i < count; i += 1) {
      const x = -19 + random() * 39;
      const z = -16 + random() * 32;
      if (x > 3.2 && x < 11) continue;
      const o = box(root, x, districtHeight(x, z) + 0.033, z, 0.05 + random() * 0.09, 0.015, 0.07 + random() * 0.09, i % 3 ? m.moss : m.brass);
      o.rotation.y = random() * 6.28;
    }
    return { root };
  },
};
